import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import getAncestorsDetails from '../1-common/apis/getAncestorsDetails';
import getConfig from '../1-common/apis/getConfig';
import { getOfflineAuthor } from '../1-common/utils/author';
// Generic node resolvers that can be used for any node type
export const EPNodeFieldsResolvers = {
    async translationInfo() {
        return {
            sourceLang: 'en',
            targetLang: 'en',
        };
    },
    async config(node, context) {
        return getConfig(getCurrentUserID(), node.id);
    },
    async ancestorsDetails(node, context) {
        return getAncestorsDetails(getCurrentUserID(), node.id);
    },
    async author() {
        return getOfflineAuthor();
    }
};
